export enum userCodes {
  ALREADY_EXISTS = 'userCode_2',
  NOT_EXISTS = 'userCode_6',
  TOKEN_NOT_EXISTS = 'userCode_8',
}
